import { CrudPage } from "../components/CrudPage";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { formatRupiah, formatTanggal } from "../lib/format";

const empty = { nama_kain: "", harga_default_per_yard: 0, harga_default_per_satuan: 0, satuan_default: "yard", keterangan: "" };

const columns = [
    { key: "nama_kain", header: "Nama Kain", className: "font-medium text-slate-900" },
    { key: "harga", header: "Harga Default", render: (r) => <span className="num-tabular">{formatRupiah(r.harga_default_per_satuan ?? r.harga_default_per_yard)} <span className="text-xs text-slate-400">/ {r.satuan_default || "yard"}</span></span> },
    { key: "keterangan", header: "Keterangan", className: "text-slate-500 max-w-xs truncate" },
    { key: "created_at", header: "Dibuat", render: (r) => formatTanggal(r.created_at), className: "text-slate-500" },
];

const renderForm = (form, setForm) => {
    const currentHarga = form.harga_default_per_satuan || form.harga_default_per_yard || 0;
    const currentSatuan = form.satuan_default || "yard";
    return (
        <div className="space-y-4">
            <div>
                <Label>Nama Kain <span className="text-rose-600">*</span></Label>
                <Input data-testid="kain-form-nama" value={form.nama_kain} onChange={(e) => setForm({ ...form, nama_kain: e.target.value })} className="mt-1.5 rounded-xl" placeholder="Contoh: Katun Combed 30s" />
            </div>
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <Label>Satuan Default</Label>
                    <Select value={currentSatuan} onValueChange={(v) => setForm({ ...form, satuan_default: v })}>
                        <SelectTrigger data-testid="kain-form-satuan" className="mt-1.5 rounded-xl"><SelectValue /></SelectTrigger>
                        <SelectContent><SelectItem value="yard">yard</SelectItem><SelectItem value="meter">meter</SelectItem></SelectContent>
                    </Select>
                </div>
                <div>
                    <Label>Harga Default / {currentSatuan} (Rp)</Label>
                    <Input type="text" inputMode="decimal" data-testid="kain-form-harga" value={currentHarga}
                        onChange={(e) => { setForm({ ...form, harga_default_per_satuan: e.target.value, harga_default_per_yard: e.target.value }); }}
                        className="mt-1.5 rounded-xl" placeholder="25000" />
                </div>
            </div>
            <div>
                <Label>Keterangan</Label>
                <Textarea value={form.keterangan} onChange={(e) => setForm({ ...form, keterangan: e.target.value })} className="mt-1.5 rounded-xl" rows={2} placeholder="Karakteristik / catatan..." />
            </div>
        </div>
    );
};

const validate = (f) => { if (!f.nama_kain?.trim()) return "Nama kain wajib diisi"; return null; };

export default function JenisKainPage() {
    return (
        <CrudPage title="Master Jenis Kain" subtitle="Katalog jenis kain untuk sub-kontrak." endpoint="/master/kain" entityLabel="Kain" columns={columns} emptyForm={empty} renderForm={renderForm} validate={validate} testidBase="kain" />
    );
}
